<template>
  <div class="proposals-read-owner">
    <form-toggler
      :value="owned"
      @input="update"
    />

    <modal-confirmation
      v-if="updating"
      :loading="loading"
      :title="title"
      :color="color"
      @close="close"
      @confirm="submit"
    >
      <template v-if="owned">
        Ao confirmar, outra pessoa poderá reivindicar a responsabilidade desta proposta.
        <br><br>
        Deseja confirmar a desistência?
      </template>

      <template v-else>
        Clique em confirmar para se tornar o responsável pelo acompanhamento desta proposta.
        <br><br>
        Assumir a responsabilidade permite a identificação do seu usuário em relatórios e o
        controle da mesa de crédito. Essa ação não remove ou fornece maiores permissões em relação
        a outros usuários.
        <br><br>
        Deseja confirmar a responsabilidade?
      </template>
    </modal-confirmation>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  import FormToggler from '@cordel/components/Form/Toggler.vue';
  import ModalConfirmation from '@cordel/components/Modal/Confirmation.vue';

  export default {
    name: 'ProposalsReadOwner',
    components: {
      FormToggler,
      ModalConfirmation,
    },
    props: {
      proposal: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        updating: false,
      };
    },
    computed: {
      ...mapState([
        'auth',
        'proposals',
      ]),

      loading() {
        return this.proposals.getOwnership.loading || this.proposals.leaveOwnership.loading;
      },

      owned() {
        return !!(this.proposal.owner && this.proposal.owner.id === this.auth.user.id);
      },
      color() {
        if (this.owned) {
          return 'danger';
        }

        return undefined;
      },
      title() {
        if (this.owned) {
          return 'Abandonar responsabilidade';
        }

        return 'Assumir responsabilidade';
      },
    },
    methods: {
      update(value) {
        if (this.proposal.seller.id === value) {
          return;
        }

        this.updating = true;
      },

      close() {
        this.updating = false;
      },
      submit() {
        let endpoint = 'proposals/get_ownership';

        if (this.owned) {
          endpoint = 'proposals/leave_ownership';
        }

        this.$store.dispatch(endpoint, {
          id: this.proposal.id,
        }).then(this.close);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .proposals-read-owner {
  }
</style>
